__turbopack_context__.v({
  "alert-banner": "unavailable-course-module-scss-module__Z6K6rG__alert-banner",
  "loading-container": "unavailable-course-module-scss-module__Z6K6rG__loading-container",
  "recommendations-container": "unavailable-course-module-scss-module__Z6K6rG__recommendations-container",
});
